(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    /* BISOU PRODUCT PAGE CUSTOMIZATION
     Restores ADD TO CART · current price only inside the stable main product buy area wrapper.
  */
  (() => {
    const buyAreas = document.querySelectorAll('.bisou-main-product-buy-area');

    buyAreas.forEach((buyArea) => {
      const form = buyArea.querySelector('form') || buyArea.closest('form');
      const button = buyArea.querySelector('button[ref="addToCartButton"][name="add"], button[type="submit"][name="add"]');
      const label = button?.querySelector('.add-to-cart-text-_content');
      const variantInput = form?.querySelector('input[name="id"]');
      const priceMapScript = buyArea.querySelector('[data-bisou-atc-price-map]');
      const baseLabel = buyArea.getAttribute('data-bisou-atc-label') || 'ADD TO CART';
      let priceMap = {};

      if (!button || !label) return;

      try {
        priceMap = priceMapScript ? JSON.parse(priceMapScript.textContent || '{}') : {};
      } catch (error) {
        priceMap = {};
      }

      const updateLabel = () => {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const variantId = variantInput?.value;
        const price = priceMap[variantId] || buyArea.getAttribute('data-bisou-atc-price');
        if (!price) return;

        label.textContent = `${baseLabel} · ${price}`;
      };

      updateLabel();
      form?.addEventListener('change', () => window.setTimeout(updateLabel, 0));

      if (variantInput) {
        const observer = new MutationObserver(updateLabel);
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  })();

  /* BISOU PRODUCT PAGE CUSTOMIZATION — MAIN CART DRAWER
     Opens the theme's existing cart drawer only after a successful native add from the main product buy area.
  */
  document.addEventListener('cart:update', (event) => {
    const eventSource = event.target instanceof Element ? event.target : null;
    const mainBuyArea = eventSource?.closest('.bisou-main-product-buy-area');

    if (!mainBuyArea || event.detail?.data?.didError) return;

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer || cartDrawer.hasAttribute('auto-open')) return;

    cartDrawer.open?.();
  });
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — MAIN CART DRAWER */

  /* END BISOU PRODUCT PAGE CUSTOMIZATION */

  /* BISOU PRODUCT PAGE CUSTOMIZATION — DELIVERY COUNTDOWN
     Corrects only the main product delivery message and hides the legacy cutoff micro-line.
  */
  (() => {
    const cards = document.querySelectorAll(
      '.bisou-main-product-buy-area [data-bisou-delivery-countdown]'
    );

    if (!cards.length) return;

    const cutoffMinutes = 20 * 60;
    const tampaTimeFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hourCycle: 'h23',
      hour: '2-digit',
      minute: '2-digit',
    });

    const getTampaMinutes = () => {
      const parts = tampaTimeFormatter.formatToParts(new Date());
      const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
      const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);
      return hour * 60 + minute;
    };

    const formatRemainingTime = (remainingMinutes) => {
      const hours = Math.floor(remainingMinutes / 60);
      const minutes = remainingMinutes % 60;

      if (hours < 1) return `${minutes}m`;
      return `${hours}h ${String(minutes).padStart(2, '0')}m`;
    };

    const updateCard = (card) => {
      const body = card.querySelector('[data-bisou-delivery-body]');
      const micro = card.querySelector('[data-bisou-delivery-micro]');

      if (!body) return;

      const currentMinutes = getTampaMinutes();

      let nextMessage;

      if (currentMinutes < cutoffMinutes) {
        const remainingMinutes = cutoffMinutes - currentMinutes;
        nextMessage = `Order within ${formatRemainingTime(remainingMinutes)} and we’ll deliver today.`;
      } else {
        nextMessage =
          'Need it today? Place your order and we’ll confirm the earliest available delivery time.';
      }

      if (body.textContent.trim() !== nextMessage) body.textContent = nextMessage;

      if (micro) {
        micro.textContent = '';
        micro.hidden = true;
      }
    };

    const updateAllCards = () => cards.forEach(updateCard);

    updateAllCards();
    window.setInterval(updateAllCards, 30000);

    cards.forEach((card) => {
      const body = card.querySelector('[data-bisou-delivery-body]');
      if (!body) return;

      const observer = new MutationObserver(() => updateCard(card));
      observer.observe(body, { childList: true, characterData: true, subtree: true });
    });
  })();
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — DELIVERY COUNTDOWN */
  } catch(e) { console.error(e); }
})();

})();
